module.exports = __webpack_public_path__ + "static/img/nyjx.a983f3c1.png";